import React, { useMemo } from "react";
import { Spin } from "antd";
import { LoadingOutlined } from "@ant-design/icons";
import store from "../stores/StoreRoot";
// import "./LoadingAnimation.css";

function LoadingAnimation(props) {
  let height = props?.height ? props?.height : 300;
  let message = props?.message ? props?.message : ""; // "Loading...";
  let delay = props?.delay ? props?.delay : 200;
  let marginLeft = props?.marginLeft ? props?.marginLeft : 0;
  message = store.main.translateText(message);

  const antIcon = (
    <LoadingOutlined
      style={{
        fontSize: store.isPhone ? 28 : 24,
        marginBottom: store.isPhone ? 10 : 2,
      }}
      spin
    />
  );

  const style = {
    justifyContent: "center",
    display: "flex",
    alignItems: "center",
    verticalAlign: "center",
    marginLeft: marginLeft,
    height,
    ...(props?.style || {}),
  };

  const spinComponent = useMemo(
    () => (
      <Spin
        size={store.isPhone ? "large" : "default"}
        tip={message}
        indicator={antIcon}
        delay={delay}
      >
        {message && <div style={{ padding: 20, width: 300 }} />}
      </Spin>
    ),
    [store.isPhone, message, antIcon, delay],
  );

  return (
    <div className="ar-fadein" style={style}>
      {spinComponent}
    </div>
  );
}
export default React.memo(LoadingAnimation);
